import { useCallback, useMemo, createContext } from 'react';

// Context
import { useGlobalState } from '@wearetla/tla-essentials-tools/utilities/global-state';
import { useStorage } from '@wearetla/tla-essentials-tools/utilities/storage';
import { useTranslation } from '/utilities/i18n';

// Data
import { getEmptyLocation } from '/data/empty-location';

export const LocationsContext = createContext({
	selectedLocation: null,
	locations: [],
	changeLocation: () => {},
});

export const LocationsProvider = ({ children }) => {
	const { locations: rawLocations, venues: rawVenues } = useGlobalState();
	const { locationId: rawLocationId, setData } = useStorage();
	const { language, t } = useTranslation();

	const locationId = useMemo(() => rawLocationId ?? false, [rawLocationId]);
	const emptyLocation = useMemo(() => getEmptyLocation(language), [language]);

	
	const locations = useMemo(() => (rawLocations ?? []), [rawLocations]);
	const locationOptions = useMemo(() => [emptyLocation, ...locations], [emptyLocation, locations]);
	const venues = useMemo(() => (rawVenues ?? []), [rawVenues]);
	const venueOptions = useMemo(() => [
		{
			label: t('Tümü'),
			value: false,
		},
		...venues,
	], [emptyLocation, venues]);

	const selectedLocation = useMemo(
		() => locationOptions.find((b) => b.id === locationId),
		[locationId, locationOptions]
	);

	const changeLocation = useCallback((location) => {
		setData('locationId', location?.id ? location?.id : false);
	}, []);

	const api = useMemo(
		() => ({
			selectedLocation,
			locations,
			locationOptions,
			venues,
			venueOptions,
			emptyLocation,
			changeLocation,
		}),
		[selectedLocation, locations, locationOptions, changeLocation]
	);

	return <LocationsContext.Provider value={api}>{children}</LocationsContext.Provider>;
};
